import { Component, EventEmitter, Input, Output } from '@angular/core';

export type AiPanelState = 'idle' | 'loading' | 'ready' | 'error' | 'no-answers';

export interface AiStatChip {
  value: number | string;
  labelKey: string;
  variant?: 'warning' | 'danger' | 'success';
}

@Component({
  selector: 'app-ai-summary-panel',
  templateUrl: './ai-summary-panel.component.html',
  styleUrls: ['./ai-summary-panel.component.scss'],
})
export class AiSummaryPanelComponent {
  @Input() state: AiPanelState = 'idle';
  @Input() summary = '';
  @Input() stats: AiStatChip[] = [];
  @Input() titleKey = '';
  @Input() generateKey = '';
  @Input() regenerateKey = '';
  @Input() loadingKey = '';
  @Input() errorKey = '';
  @Input() noAnswersKey?: string;
  @Input() hintKey?: string;
  @Input() canRegenerate = true;
  @Input() minutesUntilRegen = 0;

  @Output() generate = new EventEmitter<void>();

  onHeaderClick(): void {
    if (this.state === 'idle') {
      this.generate.emit();
    }
  }
}
